import UibookCase from 'uibook/case'
import React from 'react'
import TelegramChip from '../TelegramChip'

const I18N = {
  ru: {
    enabled: 'Активный чип',
    disabled: 'Отключенный чип',
    dark: 'Чип в dark теме',
    hintEnabled: 'Базовое интерактивное состояние.',
    hintDisabled: 'Disabled блокирует onClick и снижает контраст.',
    hintDark: 'Проверка цветов на темной теме.',
  },
  en: {
    enabled: 'Enabled chip',
    disabled: 'Disabled chip',
    dark: 'Chip on dark theme',
    hintEnabled: 'Default interactive state.',
    hintDisabled: 'Disabled blocks click and lowers contrast.',
    hintDark: 'Color behavior on dark theme.',
  }
}

const PROPS = {
  onClick: UibookCase.event('onTelegramChipStateClick')
}

export default {
  background: 'dark',
  component: TelegramChip,
  i18n: true,
  cases: [
    locale => <UibookCase props={{ ...PROPS, mode: 'elevated', description: I18N.en.hintEnabled }}>
      { I18N[locale].enabled }
    </UibookCase>,
    locale => <UibookCase props={{ ...PROPS, mode: 'mono', disabled: true, description: I18N.en.hintDisabled }}>
      { I18N[locale].disabled }
    </UibookCase>,
    locale => <UibookCase props={{
      ...PROPS,
      mode: 'outline',
      before: <span aria-hidden='true'>*</span>,
      description: I18N.en.hintDark
    }}>
      { I18N[locale].dark }
    </UibookCase>
  ]
}
